const degrees = [
  {
    school: 'University of Pennsylvania',
    degree: 'Ph.D. Electrical and Systems Engineering',
    link: 'https://www.upenn.edu/',
    start_year: 2024,
    end_year: 'present',
  },
  {
    school: 'ETH Zurich',
    degree: 'M.S. Robotics, Systems and Control',
    link: 'https://ethz.ch/en.html',
    start_year: 2020,
    end_year: 2023,
  },
  {
    school: 'Tsinghua University',
    degree: 'B.S. Mechanical Engineering (Major)',
    link: 'https://www.tsinghua.edu.cn/en/',
    start_year: 2016,
    end_year: 2020,
  },
  {
    school: 'Tsinghua University',
    degree: 'B.S. Economics (Minor)',
    link: 'https://www.tsinghua.edu.cn/en/',
    start_year: 2016,
    end_year: 2020,
  },
  {
    school: 'Delft University of Techonolgy',
    degree: 'Exchange M.S. Mechanical Engineering',
    link: 'https://www.tudelft.nl/en/',
    start_year: 2018,
    end_year: 2019,
  },
];

export default degrees;
